$(document).on('click', ".video-btn", function(e) {
    e.preventDefault();
    $(".video-popup-overlay,.video-popup-iframe-container,.video-popup-container,.video-popup-close").show();
    
    var srchref='',autoplay='',id=$(this).data('id');
    if($(this).data('type') == 'vimeo') var srchref="//player.vimeo.com/video/";
    else if($(this).data('type') == 'youtube') var srchref="https://www.youtube.com/embed/";
    
    if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
    
    $(".video-popup-iframe").attr('src', srchref+id+autoplay);
    
    $(".video-popup-iframe").on('load', function() {
      $(".video-popup-container").show();
    });
  });
  
  $(".video-popup-close, .video-popup-overlay").on('click', function(e) {
    $(".video-popup-iframe-container,.video-popup-container,.video-popup-close,.video-popup-overlay").hide();
    $(".video-popup-iframe").attr('src', '');
  });


//  var flavours =  $('.flavours-item');

// flavours.each(function( index ) {
//   console.log( index + ": " + $( this ).text() );
//       var selector =  $( this ).find('.select-item select');
//       var total_quantiy =0;
//       selector.on('selectric-change', function(event, element, selectric) {
//         total_quantiy += parseInt(element.value);
//         $('.quantity-count').text(total_quantiy);

//             console.log("event",total_quantiy);
//       });


// });

// selling-plans


$('.selling-plans').on('change', function(index) {
   console.log("treess__",$(this).val());

  var target = $('.purchase-items input[name="selling_plan"]');
  if($('.purchase-item.save').hasClass('checked')){
    target.val( this.value);
    $('.purchase-item.save').find('input[name="purchase_option"]').attr('data-selling-id', this.value);
  }


});

$('.selling-plans').on('selectric-open', function(index) {
  var selected_value =   $( ".selling-plans option:selected" ).val();
  $('.purchase-item.save').find('input[name="purchase_option"]').trigger('click');

  $('.purchase-item.save').find('input[name="purchase_option"]').attr('data-selling-id', selected_value);

  console.log("treess__",$(this).val());

})



    var selector =  $('.select-item select');
    selector.on('change', function(index) {
      var total_quantiy = 0;
      $(".select-item select option:selected").each(function(){
        if($(this).val()){
          // total_quantiy = parseInt(total_quantiy) + (parseInt($(this).val()) || 0);
          total_quantiy += Number($(this).val());
        }
      });

      if($('.quantity-count').length > 0){
        var units = parseInt($('.quantity-count').data('unit')),
        singular_unit_name = $('.quantity-count').data('singular-unit'),
        plural_unit_name = $('.quantity-count').data('plural-unit'),
        get_meal_count = parseInt($('.meal-count').attr('meal-count')),
        singular_value_name = $('.meal-count').data('singular-value'),
        plural_value_name = $('.meal-count').data('plural-value');

        var totalUnits = total_quantiy * units,
        unitDesc = '${totalUnits} '+totalUnits > 1 ? plural_unit_name : singular_unit_name,
        meal_count = get_meal_count * total_quantiy,

        unitDesc = `${totalUnits} ${totalUnits > 1 ? plural_unit_name : singular_unit_name}` 
        valueDesc = `${meal_count} ${meal_count > 1 ? plural_value_name : singular_value_name}`;
        $('.quantity-count').text(unitDesc);
        $('.meal-count').text(valueDesc);
      }

      $('.prod-price').each(function(){
        var da_price = $(this).attr('data-val');
        da_price = parseInt(da_price) * total_quantiy;
        $(this).text(currency_symbol + da_price / 100);
        var da_compare_price = $(this).attr('data-compare-val');
        da_compare_price = parseInt(da_compare_price) * total_quantiy;
        if(da_compare_price > 0){
          $(this).prepend('<del>'+currency_symbol + da_compare_price / 100+'</del> ');
        }
      });

      $('.per-meal').each(function(){
        var product_total_price = $(this).parent().parent().find('.prod-price-main').text();
        product_total_price = product_total_price.replace(currency_symbol, '').trim();
        product_total_price = Number(product_total_price).toFixed(2);
        console.log('meal price = ' + product_total_price);
        var per_meal_price = (product_total_price / meal_count).toFixed(3);
        per_meal_price = per_meal_price.substring(0, per_meal_price.indexOf('.') + 3);
        $(this).text(currency_symbol + per_meal_price);
      })
      

      

      if($(this).val() > 0){
      // select-item
      $(this).parents('.select-item').find('input[name="quantity"]').val($(this).val());
      }else{
      $(this).parents('.select-item').find('input[name="quantity"]').val(0);
  
      }


    });




    $('.cart-trigger').on('click', function() {
      $('body').addClass('cartShow')
    })
    // $('.product-cart-wrap').on('click', function() {
    //     $('body').removeClass('cartShow')
    // })
   
    $('.product-cart-main-area').on('click', function(e) {
      e.stopPropagation()
  })




      function closeCart(e,el){
        e.preventDefault();
        $('body').removeClass('cartShow')
    }
    
    $(document).on("click",".product-cart-overlay",function(e) {
      e.preventDefault();
      $('body').removeClass('cartShow')
    });


    if($('.grid-item').length > 0){
      $('.grid-item').on('click', function(){
        if (!$(this).hasClass('selected')) {
          $('.grid-item').removeClass('selected');
          $(this).addClass('selected');
        }

        let varID = $(this).data('var-id');
        $('input[name="id"]').val(varID);
      });
    }
    
    $(".add-to-cart-btn-grid").on("click", function (e) {
      // ADD GRID ADD TO CART
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).parents('.product-detail-item').find('form').serialize(),
        success: function (e) {
            $("body").addClass("cartShow");
            get_cart_details();
        },
        error: "addToCartFail"
      });
    })


      $("body").on("click",'.add-to-cart-btn', function (e) {
        e.preventDefault();
        var success_direction = $(this).attr('direction');
   
        var items = [];
        $(".flavours-item.selected").each(function(){
          var quantity = $(this).find('.select-item input[name="quantity"]').val();
          var id = $(this).find('.select-item input[name="id"]').val();
          var selling_plan =  $('input[name="selling_plan"]').val();
          var preorder = false;
          if($(this).hasClass('preorder-flavour-item')){
            preorder = $(this).data('preorder-id');
          }
          var object = {};
          if(preorder ){
            object = {
              'id': id,
              'quantity': quantity,
              'selling_plan' : preorder
            }
          } else if(selling_plan > 0) {
        
              object = {
                'id': id,
                'quantity': quantity,
                'selling_plan' : selling_plan
              }
          } else {
        
            object = {
              'id': id,
              'quantity': quantity
            }
          }
          items.push(object);
        });

        let formData = {
          'items': items
        };


          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: formData,
            success: function (e) {
              if(success_direction == 'goto cart'){
                location.href = '/checkout';
              }else{
                //$("body").addClass("cartShow");
                get_cart_details();
              }
            },
            error: "addToCartFail"
          });


      });




      $(".btn_card-atc").on("click", function (e) {
        e.preventDefault();
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: $(this).parent().find('form').serialize(),
            success: function (e) {
                $("body").addClass("cartShow");
                get_cart_details();
            },
            error: "addToCartFail"
          });

      });

      // $(".btn_upsell-atc").on("click", function (e) {
      //   e.preventDefault();
      //     $.ajax({
      //       type: "POST",
      //       url: "/cart/add.js",
      //       dataType: "json",
      //       data: $(this).next().serialize(),
      //       success: function (e) {
      //           $("body").addClass("cartShow");
      //           get_cart_details();
      //       },
      //       error: "addToCartFail"
      //     });
      // });

      

      function upsell_atc(e , el){
        e.preventDefault();
        $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(el).parent().find('.shopify-product-form').serialize(),
          success: function(data) {
            get_cart_details();
          },
          error: 'addToCartFail'
      });

      }





  

      function upgrader_sellingplan(e, el){
        e.preventDefault();
       
        var selling_plan =  $(el).closest('.cart-product__item').find('input[name="selling_plan"]').val();
        var upgrade_id =  $(el).closest('.cart-product__item').find('.item-count').data('id');
        var quantity =  $(el).closest('.cart-product__item').find('.item-count').val();

        
        // console.log("id", upgrade_id);
        // console.log("selling_plan", selling_plan);
        // console.log("quantity", parseInt(quantity));


        var data = { updates: {} };
        data.updates[upgrade_id] = '0';
        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(res) {
            var upgrade_data  = {
                  "id": upgrade_id,
                  "quantity": parseInt(quantity),
                  "selling_plan": selling_plan
                }
                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: upgrade_data,
                  success: function (e) {
               
                      get_cart_details();
                  },
                  error: "addToCartFail"
                });


          }
        });
  
      }





  function get_cart_details(){
    /*fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {

        var cart_html = $(cartData);
        var cart_items = $(".product-cart-wrap", cart_html);
        $(".product-cart-wrap").replaceWith(cart_items);

      });*/
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_count = $(".cart-trigger dfn", cart_html);
        $(".cart-trigger dfn").replaceWith(cart_count);
        /*setTimeout(
          function() 
          {
              $('.cart-upsell__products').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                });
          }, 700);*/
      });
      
  
  };


  function change_qty($input){
    var variant_id= $($input).attr("data-id");
    var quantity= $($input).val();          
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {               
        get_cart_details();
      }
    });
  };



  function increaseItem(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = ('0' + value).slice(-2);            
    change_qty($input);
  }
  
  function decreaseItem(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = ('0' + value).slice(-2);         
        change_qty($input);
    }
  }


  function itemRemove(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        get_cart_details();
      }
    });
  }




  
// customer panel
$('.reset-pass').click(function(e){
  e.preventDefault();
  $('.customer__login').addClass('show-reset');
});
$('.back-to-login').click(function(e){
  e.preventDefault();
  $('.customer__login').removeClass('show-reset');
});

// var my_country = $('.address-country').attr('data-default');
// $('.address-country').val(my_country);

$('.customer__nav-url_tab').click(function(e){
  e.preventDefault();
  var my_tab = $(this).attr('data-target');
  $('.customer__nav-url').removeClass('active');
  $(this).addClass('active');
  $('.customer__tab-content').removeClass('active');
  $(my_tab).addClass('active');
});


$('.select-btn').on('change', function(){
  var selected_shake = $(this).val();
  $('.ms-tab').removeClass('active');
  $(selected_shake).addClass('active');
});

$('.com-tab__item').on('click', function(){
  var selected_tab = $(this).attr('data-target');
  var selected_tab_logo = $(this).find('img').attr('src');
  var logo_height = $(this).attr('data-height');
  $('.ms-tab').removeClass('active');
  $(selected_tab).addClass('active');

  $('.com-tab__item').removeClass('active');
  $(this).addClass('active');

  $('.logo-changable').attr('src', selected_tab_logo);
  if(logo_height != ''){
    $('.logo-changable').css('height', logo_height);
  }else{
    $('.logo-changable').css('height', 36);
  }
});

// $('.bss-rating').click(function(e){
//   e.preventDefault();
// });


var lastScrollTop = 0;
$(window).scroll(function(event){
   var scroll = $(this).scrollTop();
   if (scroll > lastScrollTop){
    $("body").removeClass("header-fixed_visible");
    if (scroll >= 150) {
      $("body").addClass("header-fixed");
    }else{
      $("body").removeClass("header-fixed");
    }
   } else {
    if (scroll >= 150) {
      $("body").addClass("header-fixed_visible");
  }else{
    $("body").removeClass("header-fixed_visible");
  }
  if (scroll <= 149) {
    $("body").removeClass("header-fixed");
  }
   }
   lastScrollTop = scroll;
});


// Define the Function targetBlank()

function targetBlank() {
  // remove subdomain of current site's url and setup regex
  var internal = location.host.replace("www.", "");
      internal = new RegExp(internal, "i");
      
  var a = document.getElementsByTagName('a'); // then, grab every link on the page
  for (var i = 0; i < a.length; i++) {
    var href = a[i].host; // set the host of each link
    if( !internal.test(href) ) { // make sure the href doesn't contain current site's host
      a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
    }
  }
};

targetBlank();

// $('.add-to-cart-btn_featured').click(function(){
//   $(this).text('Checking out');
// });




$('.testimonials__reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.testimonials__logos',
  adaptiveHeight: true,
  infinite: false,
});
$('.testimonials__logos').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.testimonials__reviews',
  dots: false,
  infinite: false,
  // centerMode: true,
  focusOnSelect: true,
  variableWidth: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
      }
    }
  ]
});


$('.slider-arrows__left').click(function(){
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.slider-arrows__right').click(function(){
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

var my_country = $('.address-country').attr('data-default');
$('.address-country').val(my_country);


$('.cart-upsell__products').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
  infinite: true,
});

$('.purchase-item_one-time').click(function(){
  $(this).find('input').prop("checked", true).trigger("change");
})






$('.action-video__items').slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});

$('.action-video__prev-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.action-video__next-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// End Action Video Slidar (Collection Page)


// Start Action Video Play On off

$('.action-video__item').on('click', function () {
    var $videoContainer = $(this);
    var $video = $videoContainer.find('video');
    var $playBtn = $videoContainer.find('.action-video__playbtn');
    var isPlaying = $video.attr('playsinline') !== undefined;
    if (isPlaying) {
        $video[0].pause();
        $video.removeAttr('playsinline');
        $video.removeAttr('loop');
        $playBtn.show();
    } else {
        $('.action-video__item').each(function () {
            var $otherVideo = $(this).find('video');
            var $otherPlayBtn = $(this).find('.action-video__playbtn');
            if ($otherVideo.attr('playsinline') !== undefined && $otherVideo[0] !== $video[0]) {
                $otherVideo[0].pause();
                $otherVideo.removeAttr('playsinline');
                $otherVideo.removeAttr('loop');
                $otherPlayBtn.show();
            }
        });
        $video.attr('playsinline', 'playsinline');
        $video.attr('loop', 'loop');
        $video[0].play();
        $playBtn.hide();
    }
});
$('.action-video__playbtn').on('click', function (e) {
    e.stopPropagation();
    $(this).closest('.action-video__item').trigger('click');
});
